import { GenericService, getApiUrlPath, IProductGroupRequest, IProductGroupResponse } from "@/models";


export class ProductGroupFactory extends GenericService<IProductGroupRequest,
  IProductGroupResponse> {
  constructor() {
    super({
      prefix: getApiUrlPath("ProductGroup")
    });
  }
}

